import React, { useEffect, useState } from 'react';
import { get, isEmpty, size } from 'lodash';
import { Field } from 'redux-form';
import RenderSelect from '../RenderSelect';
import PlazaController from '../../../controllers/plaza/PlazaController';
import { fullPlazaNameLabel } from '../../../constants/naming';
import { mockedPlazaList } from '../../../../screens/Reports/components/DeliveredEnergy/mockedData';
import { isDemo } from '../../Echarts/helpers/helper';

export const getFilteredPlazasOptions = async (showHidden = false) => {
  try {
    const plazas = isDemo() ? mockedPlazaList.payloads : await PlazaController.getAll({ page_token: 0, page_size: 999 }, { showHidden });
    const plazaList = PlazaController.sortByName(plazas).filter(({ chargerCount }) => chargerCount >= 1);
    const opts = PlazaController.makeOptionsWithStatus(plazaList);
    const plazaUuid = size(opts) ? get(opts, '0.value', null) : null;

    return {
      plazas: opts,
      plazaUuid,
    };
  } catch (e) {
    console.error(e);

    return {
      plazas: [],
      plazaUuid: null,
    };
  }
};

const RenderPlazaSelectComponent = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getFilteredPlazasOptions().then(({ plazas }) => {
      setOptions(plazas);
    });
  }, []);

  if (isEmpty(options)) return null;

  return (
    <Field
      key={`${props.name}_name`}
      name={props.name}
      component={RenderSelect}
      floatingLabelText={fullPlazaNameLabel}
      className={props.className}
      fullWidth
      options={options}
      multiple={props.multiple}
      showCheckboxes={props.showCheckboxes}
      clearable
      withSelectAll
    />
  );
};

export default RenderPlazaSelectComponent;
